export function htmlEnc(input: unknown, isAttr = true) {
  let result = String(input);
  result = result.replace(/&/g, '&amp;');
  result = result.replace(/>/g, '&gt;');
  result = result.replace(/</g, '&lt;');
  if (isAttr) {
    result = result.replace(/"/g, '&quot;');
  }
  result = result.replace(/\u00a0/g, '&nbsp;');
  return result;
}
